import { isNil } from 'lodash';
import { useCallback, useContext } from 'react';
import { StyleProp, StyleSheet, ViewStyle } from 'react-native';
import { MBClearButton } from '@shared/components/MBButton';
import { MBView } from '@shared/components/MBView';
import { Text } from '@shared/components/Text';
import { View } from '@shared/components/View';
import { FileUpload } from '@shared/components/blocks/types';
import { MBIconV2 } from '@shared/components/image';
import { MBTouchableOpacity } from '@shared/components/touchable';
import { ColorThemeContext, Colors, grid } from '@shared/styles';
import { MBLinking } from '@shared/util/linking';

interface Props {
  file: FileUpload;
  style?: StyleProp<ViewStyle>;
  editable: boolean;
  onClear?(): void;
}

export function FileListItem({ file, style, onClear, editable }: Props) {
  const colors = useContext(ColorThemeContext);

  const openFile = useCallback(() => MBLinking.open(file.url), [file.url]);

  if (isNil(file)) {
    return null;
  }

  return (
    <MBView row centerVertically style={style}>
      <View flex>
        <MBTouchableOpacity
          style={[styles.fileBox, { backgroundColor: colors.backgroundInactive }]}
          onPress={openFile}
        >
          <View absolute padding={1}>
            <MBIconV2 name="file" size={grid(4)} color={colors.foregroundActive} />
          </View>
          <Text size="body1" numberOfLines={1} style={{ paddingLeft: grid(4) }}>
            {file.name}
          </Text>
        </MBTouchableOpacity>
      </View>
      {editable && !isNil(onClear) && <MBClearButton onPress={onClear} />}
    </MBView>
  );
}

const styles = StyleSheet.create({
  iconBorder: {
    borderWidth: 2,
    borderColor: Colors.v2.white,
  },
  fileBox: {
    borderRadius: grid(1),
    alignSelf: 'flex-start',
    maxWidth: '100%',
    flexDirection: 'row',
    padding: grid(2),
    alignItems: 'center',
  },
});
